import styles from './ProjectTrafficLightStatusSwitcherCell.module.scss';

import clsx from 'clsx';

import { ProjectTrafficLightStatusSwitcher } from '@work4all/components';

import { TrafficLightStatus } from '@work4all/models/lib/Enums/TrafficLightStatus.enum';

type Props = {
  value: TrafficLightStatus;
  onChange: (value: TrafficLightStatus) => void;
};

export const ProjectTrafficLightStatusSwitcherCell = ({
  value,
  onChange,
}: Props) => {
  const showOnHoverOnly = value === TrafficLightStatus.UNSET;

  return (
    <ProjectTrafficLightStatusSwitcher
      value={value}
      onChange={onChange}
      classes={{
        button: clsx({ [styles.showOnHoverOnly]: showOnHoverOnly }),
      }}
    />
  );
};
